import { useAuth } from '@esmiley/frontend-core';
import { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'redux/rootReducer';

const SCRIPT_ID = 'hjs';
const TRACKER_ID = '6671250';

const mapStateToProps = (state: RootState) => ({
  enabled: Boolean(state.settings.hotjarEnabled)
});

type StoreProps = ReturnType<typeof mapStateToProps>;

function initHotjar() {
  // sets up the hj global variable, so that we can
  // queue some commands even if the hotjar lib hasnt been yet loaded
  // see https://help.hotjar.com/hc/en-us/articles/36820006120721-Identify-API-Reference#best_practices

  // pass ?hjDebug=1 as query param or set a cookie to enable debug mode
  // see https://help.hotjar.com/hc/en-us/articles/36819964544913-Hotjar-Debug-Mode
  if (window.hj) {
    return;
  }

  window.hj = function () {
    // @ts-ignore
    // eslint-disable-next-line
    (hj.q = hj.q || []).push(arguments);
  };
}

export const Tracker: FC<StoreProps> = ({ enabled }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const setIdentification = () => {
      window.hj('identify', user.userId, {
        user_id: user.userId,
        account_id: user.accountId
      });
    };

    const insertTrackerScript = () => {
      if (document.getElementById(SCRIPT_ID)) {
        setIdentification();
        return;
      }

      initHotjar();

      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.innerHTML = `(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${TRACKER_ID},hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
      document.head.appendChild(script);
      setIdentification();
    };

    const removeTrackerScript = () => {
      document.getElementById(SCRIPT_ID)?.remove();
    };

    if (enabled) {
      insertTrackerScript();
      return;
    }

    removeTrackerScript();
  }, [enabled]);

  return null;
};

export default connect<StoreProps, unknown, unknown>(mapStateToProps)(Tracker);
